import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import { SortedList } from "../../Layout/SortedList";
import ListHeader from "./List/ListHeader";
import ListRow from "./List/ListRow";

export default class Tracking extends PureComponent {
  static propTypes = {
    isLoading: PropTypes.bool,
    isMobile: PropTypes.bool,
    tracking: PropTypes.array,
    userMetadata: PropTypes.object
  };

  static defaultProps = {
    isLoading: false,
    isMobile: false,
    tracking: [],
    userMetadata: {}
  };

  render() {
    return (
      <div className="routing__tracking">
        <SortedList
          RowComponent={ListRow}
          HeaderComponent={ListHeader}
          data={this.props.tracking}
          isLoading={this.props.isLoading}
          isMobile={this.props.isMobile}
          rowProps={{ userMetadata: this.props.userMetadata }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BillOfLading/Routing/Tracking.js